import DealsResults from "./DealsResults";

export default DealsResults;
